import { ResetButton } from 'components/secondaryMarket/shared/toolbar/ResetButton';
import { Toolbar } from 'components/secondaryMarket/shared/toolbar/Toolbar';
import { ToolbarSkeleton } from 'components/secondaryMarket/shared/toolbar/Toolbar.skeleton';
import { useBcsProductKeyAsLabel } from 'components/secondaryMarket/shared/toolbar/useBcsProductKeyAsLabel';
import { useMemo } from 'react';
import type { SecondaryMarketQuotesTabType } from 'state/workspaces/model';
import type { BcsProductKey } from 'state/workspaces/secondary-market/quotes/secondaryMarketQuotes.model';

export type SecondaryMarketToolbarProps = {
  isLoading: boolean;
  productName?: string;
  traderLabel?: string;
  bcsProductKey?: BcsProductKey;
  canResetForm: boolean;
  onResetForm?: () => void;
  type: SecondaryMarketQuotesTabType;
};

export function SecondaryMarketToolbar({
  isLoading,
  productName,
  bcsProductKey,
  traderLabel,
  canResetForm,
  onResetForm,
  type,
}: SecondaryMarketToolbarProps) {
  const reference = useBcsProductKeyAsLabel(bcsProductKey);
  const labels = useMemo(() => [productName, traderLabel, reference], [productName, reference, traderLabel]);

  if (isLoading) {
    return <ToolbarSkeleton count={3} />;
  }

  return (
    <Toolbar labels={labels} type={type}>
      {onResetForm !== undefined && <ResetButton onReset={onResetForm} isDisabled={!canResetForm} />}
    </Toolbar>
  );
}
